import {DeferredRegistry} from './deferred-registry'
import type {NavigatorRouteRegistration} from './app-routing-types'
import type {RouteObject} from 'react-router-dom'
import type {createAppScopedQueryRoute} from './future/QueryRoute'

export interface AppRegistration {
  routes: NavigatorRouteRegistration[] | RouteObject[]
}

export interface NavigatorAppRegistration extends AppRegistration {
  App?: React.ComponentType<{children?: React.ReactNode}>
  routes: NavigatorRouteRegistration[]
}

export interface DataRouterAppRegistration extends AppRegistration {
  App?: never
  routes: RouteObject[]
}

export type NavigatorAppRegistrationFn = () => NavigatorAppRegistration

export type DataRouterAppRegistrationFn = (args: {
  queryRoute: ReturnType<typeof createAppScopedQueryRoute>
}) => DataRouterAppRegistration

export type NavigatorAppRegistrationObject = {type: 'NavigatorApp'; registration: NavigatorAppRegistrationFn}
export type DataRouterAppRegistrationObject = {type: 'DataRouterApp'; registration: DataRouterAppRegistrationFn}

export type AppRegistrationObject = NavigatorAppRegistrationObject | DataRouterAppRegistrationObject

export function createNavigatorAppRegistration(
  registration: NavigatorAppRegistrationFn,
): NavigatorAppRegistrationObject {
  return {
    type: 'NavigatorApp',
    registration,
  }
}
export function createDataRouterAppRegistration(
  registration: DataRouterAppRegistrationFn,
): DataRouterAppRegistrationObject {
  return {
    type: 'DataRouterApp',
    registration,
  }
}

export function isNavigatorApp(registration: AppRegistrationObject): registration is NavigatorAppRegistrationObject {
  return registration.type === 'NavigatorApp'
}

export function isDataRouterApp(registration: AppRegistrationObject): registration is DataRouterAppRegistrationObject {
  return registration.type === 'DataRouterApp'
}

export const reactAppDeferredRegistry = new DeferredRegistry<
  NavigatorAppRegistrationObject | DataRouterAppRegistrationObject
>()

export async function getReactApp(appName: string) {
  return reactAppDeferredRegistry.getRegistration(appName).promise
}
